import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const Skills: React.FC = () => {
  const skillCategories = [
    {
      title: "Backend Development",
      icon: "⚙️",
      skills: ["C#", "Node.js", "Python", "SQL", "MongoDB", "Express.js", "Bun"]
    },
    {
      title: "Frontend Development",
      icon: "🎨", 
      skills: ["React", "TypeScript", "Angular", "HTML/CSS", "Bootstrap"]
    },
    {
      title: "Applied AI",
      icon: "🤖",
      skills: ["RAG Systems", "Agentic Chatbots", "LangGraph", "Graph Database", "LLM", "AI Development Tools"]
    },
    {
      title: "DevOps & Infrastructure",
      icon: "🚀",
      skills: ["Docker", "Self-hosting", "NAS", "Home Server Management", "Git"]
    },
    {
      title: "Game Development",
      icon: "🎮",
      skills: ["Real-time Systems", "Anti-cheat Systems", "Procedural Generation", "Client-Server Architecture"]
    },
    {
      title: "System Architecture",
      icon: "🏗️",
      skills: ["Full Stack Design", "Custom Infrastructure", "Feature Flagging", "Caching Systems"]
    }
  ];

  return (
    <section id="skills" className="py-5">
      <Container>
        <h2 className="text-center mb-5">Technical Skills</h2>
        <Row>
          {skillCategories.map((category, index) => (
            <Col md={6} lg={4} key={index} className="mb-4">
              <div className="skill-category h-100 p-4 border border-secondary rounded">
                <h5 className="text-primary mb-3">
                  <span className="me-2">{category.icon}</span>
                  {category.title}
                </h5>
                <div className="d-flex flex-wrap gap-2">
                  {category.skills.map((skill, idx) => (
                    <span key={idx} className="badge bg-dark border border-secondary">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Skills;
